export const RECEIPT_TEMPLATES = [
    {
        id: "RECEIPT_01",
        name: "Classic White",
        description: "Blan, pwòp, ofisyèl ak aksan ble MKTRANSFÈ.",
        previewClass: "bg-white text-slate-900 border-slate-200",
        accent: "#002F87",
        accent2: "#16A36D",
        surface: "#F5F7FB",
        text: "#111827",
        muted: "#6B7280",
        border: "#E2E8F0",
        dark: false,
        variant: "classic",
    },
    {
        id: "RECEIPT_02",
        name: "Dark Premium",
        description: "Nwa premium ak ble fonse pou yon aparans fintech modèn.",
        previewClass: "bg-[#07152a] text-white border-blue-900/50",
        accent: "#2F65C3",
        accent2: "#16A36D",
        surface: "#10294F",
        text: "#FFFFFF",
        muted: "#A6B5D0",
        border: "#244267",
        dark: true,
        variant: "dark",
    },
    {
        id: "RECEIPT_03",
        name: "Blue Split",
        description: "Gwo header ble ak yon kat detay klè anba li.",
        previewClass: "bg-[#002F87] text-white border-blue-700",
        accent: "#002F87",
        accent2: "#FF8C00",
        surface: "#FFFFFF",
        text: "#111827",
        muted: "#64748B",
        border: "#DCE4EF",
        dark: false,
        variant: "split",
    },
    {
        id: "RECEIPT_04",
        name: "Orange Accent",
        description: "Blan ak aksan zoranj MKTRANSFÈ ki mete montan an an valè.",
        previewClass: "bg-[#fff8ef] text-slate-900 border-orange-200",
        accent: "#FF8C00",
        accent2: "#002F87",
        surface: "#FFF3E0",
        text: "#111827",
        muted: "#7C6A55",
        border: "#F1E0CC",
        dark: false,
        variant: "orange",
    },
    {
        id: "RECEIPT_05",
        name: "Ticket Style",
        description: "Tankou yon tikè/bon ofisyèl ak liy perforasyon.",
        previewClass: "bg-white text-slate-900 border-slate-300",
        accent: "#002F87",
        accent2: "#16A36D",
        surface: "#FFFFFF",
        text: "#111827",
        muted: "#64748B",
        border: "#CDD5DF",
        dark: false,
        variant: "ticket",
    },
    {
        id: "RECEIPT_06",
        name: "Layered Blue",
        description: "Ble an kouch ak yon kat blan premium pou detay yo.",
        previewClass: "bg-gradient-to-br from-[#001e5c] to-[#2f65c3] text-white border-blue-700",
        accent: "#1749A5",
        accent2: "#16A36D",
        surface: "#FFFFFF",
        text: "#111827",
        muted: "#64748B",
        border: "#DCE4EF",
        dark: false,
        variant: "layered",
    },
    {
        id: "RECEIPT_07",
        name: "Ledger Clean",
        description: "Style ledger/bank ki mete chak done byen separe.",
        previewClass: "bg-white text-slate-900 border-slate-300",
        accent: "#002F87",
        accent2: "#16A36D",
        surface: "#F8FAFC",
        text: "#111827",
        muted: "#64748B",
        border: "#D7DEE8",
        dark: false,
        variant: "ledger",
    },
    {
        id: "RECEIPT_08",
        name: "Mobile Dark Card",
        description: "Kat mobil nwa ak seksyon ble, fèt pou ekran telefòn.",
        previewClass: "bg-[#0b1729] text-white border-slate-700",
        accent: "#2F65C3",
        accent2: "#16A36D",
        surface: "#10294F",
        text: "#FFFFFF",
        muted: "#9FB2D3",
        border: "#243A5B",
        dark: true,
        variant: "mobileDark",
    },
    {
        id: "RECEIPT_09",
        name: "Verification Focus",
        description: "Mete estati verifye a devan ak yon blòk verifikasyon vizib.",
        previewClass: "bg-[#f5f7fb] text-slate-900 border-emerald-200",
        accent: "#16A36D",
        accent2: "#002F87",
        surface: "#EAF8F2",
        text: "#111827",
        muted: "#64748B",
        border: "#BCE9D8",
        dark: false,
        variant: "verify",
    },
    {
        id: "RECEIPT_10",
        name: "Minimal Monochrome",
        description: "Nwa/blan minimalist pou yon aparans trè pwofesyonèl.",
        previewClass: "bg-white text-black border-slate-400",
        accent: "#111111",
        accent2: "#111111",
        surface: "#FAFAFA",
        text: "#111111",
        muted: "#777777",
        border: "#D7D7D7",
        dark: false,
        variant: "minimal",
    },
];

export const DEFAULT_RECEIPT_TEMPLATE = RECEIPT_TEMPLATES[0].id;

export function getReceiptTemplate(templateId) {
    return (
        RECEIPT_TEMPLATES.find((item) => item.id === templateId) ||
        RECEIPT_TEMPLATES[0]
    );
}
